class CocktailShoppingList extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.handleClick.bind(this));
  }

  buildShoppingListText() {
    const recipeName = this.dataset.recipeName || 'Cocktail Recipe';
    const groups = Array.from(this.querySelectorAll('[data-shopping-group]')).map((el) => ({
      label: el.dataset.label || null,
      items: JSON.parse(el.textContent || '[]'),
    }));

    const lines = [`${recipeName} — Shopping List`];

    groups.forEach((group) => {
      if (!group.items.length) return;
      lines.push('');
      if (group.label) lines.push(`${group.label}:`);
      group.items.forEach((item) => lines.push(`- ${item}`));
    });

    return lines.join('\n');
  }

  async handleClick() {
    const text = this.buildShoppingListText();

    if (navigator.share) {
      try {
        await navigator.share({ title: this.dataset.recipeName, text });
      } catch (error) {
        // User dismissed the native share sheet — not an error state.
      }
      return;
    }

    this.downloadAsTxt(text);
  }

  downloadAsTxt(text) {
    const filename = `${this.dataset.filename || 'shopping-list'}-${(this.dataset.recipeName || 'cocktail')
      .toLowerCase()
      .replace(/\s+/g, '-')}.txt`;
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }
}

customElements.define('cocktail-shopping-list', CocktailShoppingList);
